const common = [
  {
    path: '/redirect/:path*',
    component: () => import('@/pages/redirect')
  },
  {
    path: '/authenticator',
    component: () => import('@/pages/authenticator'),
    meta: {
      login: true
    }
  },
  {
    path: '/clear',
    component: () => import('@/pages/clear/clear')
  },
  {
    path: '/login',
    // name: 'login',
    component: () => import(/* webpackChunkName: "loginIndex" */ '@/pages/login/index.vue'),
    children: [{
      path: '',
      name: 'login',
      component: () => import(/* webpackChunkName: "loginForm" */ '@/pages/login/form.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: 'webview',
      name: 'login_webview',
      component: () => import(/* webpackChunkName: "loginForm" */ '@/pages/login/form_webview.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: 'agreement',
      name: 'login-agreement',
      component: () => import(/* webpackChunkName: "loginAgreement" */ '@/pages/login/agreement.vue')
    },
    {
      path: 'privacy',
      name: 'login-privacy',
      component: () => import(/* webpackChunkName: "loginPrivacy" */ '@/pages/login/privacy.vue')
    }
    ]
  },
  {
    path: '/city-list',
    name: 'city-list',
    component: () => import(/* webpackChunkName: "cityList" */ '@/pages/city/city-list.vue'),
    meta: {
      titleBar: {
        title: '选择城市',
        hasMenu: true
      },
      keepAlive: []
    }
  }
]

export default common
